const initialMarkdown: string = `# Welcome to Markpad!

This is a simple example Markdown file to showcase some common elements using the **Tailwind CSS** framework.

## Heading 2

### Heading 3

This is a paragraph of text. You can easily style your text using Tailwind classes, such as making text **bold**, *italic*, or adjusting the size.

![Placeholder image](https://picsum.photos/200/200)

[Visit Example](https://www.example.com)

Here's an example of a table:

| Header 1 | Header 2 |
| ---------| ---------|
| Content 1| Content 2|
| Content 3| Content 4|

Now, let's add a list:

- Item 1
- Item 2
  - Subitem 2.1
  - Subitem 2.2
- Item 3

Feel free to modify this Markdown file to suit your needs and experiment with Tailwind CSS classes.

> Tailwind CSS is a utility-first CSS framework that makes styling your projects easy and efficient. It provides a wide range of pre-designed classes that you can apply directly to your HTML elements, allowing for rapid development without the need for custom CSS.

For more information, check out the [Tailwind CSS Documentation](https://tailwindcss.com/docs).

Happy coding!
`

export default initialMarkdown
